import $ from "jquery";
import WPAPI from 'wpapi';

let config = {
    colorboxEl: $('.blocks-gallery-item').not('.custom-link'),
    workPosts: $('.archive-work .post'),
    postsContainer: $( '#posts-container' ),
    pagination: $( '.archive-pagination' ),
    protocol: window.location.protocol,
    hostname: window.location.hostname,
    catID: ''
};

if ( config.hostname == 'localhost' ) {
    config.hostname = 'localhost:3000';
}

config.apiRoot = config.protocol + '//' + config.hostname + '/wp-json/';

config.wp = new WPAPI( { endpoint: config.apiRoot } );

config.catID = typeof catObject === 'undefined' ? '' : catObject.catID;

export default config;